// import appConfig from 'appConfig';

import isMobile from 'helpers/isMobile';

type GetVideoType = {
    video: string;
    poster: string;
};

const androidMedia: GetVideoType = {
    video: 'https://mobile.appscdn.io/!VIDEO/YogaApp/Public/product/New/YG_ANDR.mp4',
    poster: 'https://mobile.appscdn.io/!VIDEO/YogaApp/Public/product/New/YG_ANDR_img.webp',
};
const iOSMedia: GetVideoType = {
    video: 'https://mobile.appscdn.io/!VIDEO/YogaApp/Public/product/New/YG_iOS.mp4',
    poster: 'https://mobile.appscdn.io/!VIDEO/YogaApp/Public/product/New/YG_iOS_img.webp',
};

export const getVideoLink: () => GetVideoType = () => {
    // This is a temporary solution until updating start screen on the mobile is implemented. Then we need to roll back the previous implementation
    return isMobile.android() ? androidMedia : iOSMedia;

    // const language = navigator.languages?.[1]?.toUpperCase() || 'EN';
    //
    // if (isMobile.android()) {
    //     // @ts-ignore
    //     return appConfig.video.videoLinks.android[language] || appConfig.video.videoLinks.android['EN'];
    // }
    //
    // // @ts-ignore
    // return appConfig.video.videoLinks.ios[language] || appConfig.video.videoLinks.ios['EN'];
};
